import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { ScientificMethod } from './components/ScientificMethod';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusesSection } from './components/BonusesSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { StorySection } from './components/StorySection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
function App() {
  return <div className="min-h-screen bg-[#0B1A0B] text-gray-200 font-sans selection:bg-[#FF6B00] selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <ScientificMethod data-id="element-3" />
      <TestimonialsSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <GuaranteeSection data-id="element-8" />
      <StorySection data-id="element-9" />
      <FAQSection data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}
export { App };